import * as React from 'react'

import { Text } from '@factorialco/deprecated-design-system'

import useFilter from 'modules/core/components/Filter/base/useFilter'
import i18n from 'modules/core/lib/i18n'

import './index.styles.css'
const RemoveValue = () => {
  const { onValueChange } = useFilter()

  const onClear = () => {
    onValueChange(undefined)
  }

  return (
    <button className={'ClearValue_clear'} onClick={onClear}>
      <Text.Normal size="300" weight="medium" color="radicalRed1200">
        {i18n.t('filters.clear_filter')}
      </Text.Normal>
    </button>
  )
}

export default RemoveValue
